import { render } from "./AlertSidebar.vue?vue&type=template&id=5536000c&scoped=true&ts=true"
import script from "./AlertSidebar.vue?vue&type=script&lang=ts"
export * from "./AlertSidebar.vue?vue&type=script&lang=ts"

import "./AlertSidebar.vue?vue&type=style&index=0&id=5536000c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5536000c"]])

export default __exports__